import { MAINTENANCE_MODE_BROADCAST_CHANNEL } from '@constants/maintenanceMode';

export type MaintenanceModeBroadcastMessage = {
  type: 'maintenance-changed';
};

/** Tell other open tabs to reload so they pick up maintenance mode immediately. */
export function broadcastMaintenanceModeChanged(): void {
  if (typeof BroadcastChannel === 'undefined') {
    return;
  }
  try {
    const channel = new BroadcastChannel(MAINTENANCE_MODE_BROADCAST_CHANNEL);
    const message: MaintenanceModeBroadcastMessage = { type: 'maintenance-changed' };
    channel.postMessage(message);
    channel.close();
  } catch {
    // BroadcastChannel may be unavailable in some environments.
  }
}

/** Full page reload so MaintenanceGate and app state match server settings. */
export function reloadForMaintenanceModeChange(): void {
  window.location.reload();
}

/** Notify other tabs and reload this tab after maintenance mode is saved. */
export function applyMaintenanceModeChangeToOpenClients(): void {
  broadcastMaintenanceModeChanged();
  reloadForMaintenanceModeChange();
}
